import { Component, Input, OnInit } from '@angular/core';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { QuestionAsset } from 'src/app/models/assets/QuestionAsset';
import { QuestionSetAsset } from 'src/app/models/assets/QuestionSetAsset';
import { Scene } from 'src/app/models/Scene';
import { FontService } from 'src/app/services/font.service';
import { ValidationService } from 'src/app/services/validation.service';

@Component({
  selector: 'app-step-quiz-results',
  templateUrl: './step-quiz-results.component.html',
  styleUrls: ['./step-quiz-results.component.scss'],
})
export class StepQuizResultsComponent implements OnInit {

  @Input('assetType') assetType: string;
  @Input('assetInScene') assetInScene: AssetInScene;
  @Input('existingAssetsInScene') existingAssetsInScene: AssetInScene[] = [];
  @Input('existingScenes') existingScenes: Scene[] = [];
  @Input('editing') editing: boolean = false;
  @Input('currentStepInfo') currentStepInfo: any;

  public fontFamilyOptions: any[];
  public fontSizeOptions: number[];
  public ionSelectFontOptions = {
    cssClass: 'select-font quizard-select'
  };

  public selectOptions = {
    cssClass: 'quizard-select'
  };

  constructor(
    public fontService: FontService,
    public validationService: ValidationService
  ) {
    this.fontFamilyOptions = this.fontService.fontFamilyOptions;
    this.fontSizeOptions = this.fontService.fontSizeOptions;
  }

  ngOnInit() { }

  getQuestionSetAsset(): QuestionSetAsset {
    return this.assetInScene.baseAsset as QuestionSetAsset;
  }

  setQuestionSetResultsTitleSize(ev, asset: AssetInScene) {
    var questionAsset: QuestionSetAsset = asset.baseAsset as QuestionSetAsset;
    var value = parseFloat(ev.target.value);
    if (value > 30) {
      value = 30;
    }

    if (value < 1) {
      value = 1;
    }

    if (!value) {
      value = 1;
    }


    value = 55 - value;
    questionAsset.resultsPageTitleSize = parseFloat(value.toFixed(1));

  }

  validateResultsTitleColour(event, assetInScene: AssetInScene) {
    var questionSetAsset: QuestionSetAsset = assetInScene.baseAsset as QuestionSetAsset;
    if (questionSetAsset.resultsPageTitleColour.trim().length == 0) {
      questionSetAsset.endPageTitleColour = "#000000";
    }
  }

  setQuestionSetResultsTextSize(ev, asset: AssetInScene) {
    var questionAsset: QuestionSetAsset = asset.baseAsset as QuestionSetAsset;
    var value = parseFloat(ev.target.value);
    if (value > 30) {
      value = 30;
    }

    if (value < 1) {
      value = 1;
    }

    if (!value) {
      value = 1;
    }


    value = 55 - value;
    questionAsset.resultsPageTextSize = parseFloat(value.toFixed(1));

  }

  validateResultsTextColour(event, assetInScene: AssetInScene) {
    var questionSetAsset: QuestionSetAsset = assetInScene.baseAsset as QuestionSetAsset;
    if (questionSetAsset.resultsPageTextColour.trim().length == 0) {
      questionSetAsset.resultsPageTextColour = "#000000";
    }
  }

  validateGeneralText(questionSetAsset: QuestionSetAsset){
    questionSetAsset.resultsPageText = questionSetAsset.resultsPageText ? questionSetAsset.resultsPageText : "";
    questionSetAsset.resultsPageText = this.validationService.removeExcessLineBreaks(questionSetAsset.resultsPageText);
  }

  validatePassedText(questionSetAsset: QuestionSetAsset){
    questionSetAsset.resultsPagePassedText = questionSetAsset.resultsPagePassedText ? questionSetAsset.resultsPagePassedText : "";
    questionSetAsset.resultsPagePassedText = this.validationService.removeExcessLineBreaks(questionSetAsset.resultsPagePassedText);
  }

  validateFailedText(questionSetAsset: QuestionSetAsset){
    questionSetAsset.resultsPageFailedText = questionSetAsset.resultsPageFailedText ? questionSetAsset.resultsPageFailedText : "";
    questionSetAsset.resultsPageFailedText = this.validationService.removeExcessLineBreaks(questionSetAsset.resultsPageFailedText);
  }

}
